import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const scannerHandler = () => {
	gsap.registerPlugin(ScrollTrigger);
	const isTablet = window.innerWidth < 992;

	const section = document.querySelector('.js-scanner-content');
	const hero = document.querySelector('.js-scanner-hero');
	const rec = document.querySelector('.js-scanner-rec');
	const scanner = document.querySelector('.js-scanner-item');

	const skeletonImg = document.querySelector('.js-scanner-img:first-of-type');
	const manImg = document.querySelector('.js-scanner-img:last-of-type');

	const scanHeight = hero.clientHeight;
	const recHeight = rec.clientHeight;
	const endY = scanHeight - recHeight;

	if (endY <= 0) return;

	gsap.set([scanner, rec], {
		y: 0,
		opacity: 0,
	});
	gsap.set(skeletonImg, { clipPath: 'inset(0 0 100% 0)' });
	gsap.set(manImg, { clipPath: 'inset(0 0 0 0)' });

	ScrollTrigger.create({
		trigger: section,
		start: isTablet ? 'top-=70 top' : 'top-=50 top',
		end: 'top top',
		onEnter: () => {
			gsap.to([scanner, rec], {
				opacity: 1,
				duration: 0.3,
				ease: 'power1.out',
			});
		},
	});

	ScrollTrigger.create({
		trigger: section,
		start: isTablet ? 'top-=70 top' : 'top-=50 top',
		end: `+=${scanHeight}`,
		pin: true,
		scrub: true,
		markers: false,
		onUpdate: (self) => {
			const progress = self.progress;

			// Анімація зображень
			const manInset = progress * 100;
			manImg.style.clipPath = `inset(${manInset}% 0 0 0)`;

			const skeletonInset = 100 - progress * 100;
			skeletonImg.style.clipPath = `inset(0 0 ${skeletonInset}% 0)`;

			// Анімація сканера
			const scannerY = endY * progress;
			scanner.style.transform = `translateX(-50%) translateY(${scannerY}px)`;
			rec.style.transform = `translateX(-50%) translateY(${scannerY}px)`;
		},
	});
};

export default scannerHandler;